// extracted by mini-css-extract-plugin
export default {"auth":"Auth_auth__e-wmP","auth-content":"Auth_auth-content__w8QlA"};